import {
    GENAI_GENERATE_REQUEST,
    GENAI_GENERATE_SUCCESS,
    GENAI_GENERATE_FAIL,
    GENAI_GENERATE_RESET,
    GENAI_JOB_DETAILS_REQUEST,
    GENAI_JOB_DETAILS_SUCCESS,
    GENAI_JOB_DETAILS_FAIL,
    GENAI_MY_JOBS_REQUEST,
    GENAI_MY_JOBS_SUCCESS,
    GENAI_MY_JOBS_FAIL,
    GENAI_TEMPLATES_REQUEST,
    GENAI_TEMPLATES_SUCCESS,
    GENAI_TEMPLATES_FAIL,
    GENAI_DELETE_JOB_REQUEST,
    GENAI_DELETE_JOB_SUCCESS,
    GENAI_DELETE_JOB_FAIL,
    GENAI_STORY_REQUEST,
    GENAI_STORY_SUCCESS,
    GENAI_STORY_FAIL,
    GENAI_APPROVE_STORY_REQUEST,
    GENAI_APPROVE_STORY_SUCCESS,
    GENAI_APPROVE_STORY_FAIL,
    GENAI_REGENERATE_STORY_REQUEST,
    GENAI_REGENERATE_STORY_SUCCESS,
    GENAI_REGENERATE_STORY_FAIL,
    GENAI_IMAGES_REQUEST,
    GENAI_IMAGES_SUCCESS,
    GENAI_IMAGES_FAIL,
    GENAI_REGENERATE_COVER_REQUEST,
    GENAI_REGENERATE_COVER_SUCCESS,
    GENAI_REGENERATE_COVER_FAIL,
    GENAI_REGENERATE_COVER_RESET,
    GENAI_APPROVE_PAGES_REQUEST,
    GENAI_APPROVE_PAGES_SUCCESS,
    GENAI_APPROVE_PAGES_FAIL,
    GENAI_REGENERATE_PAGE_REQUEST,
    GENAI_REGENERATE_PAGE_SUCCESS,
    GENAI_REGENERATE_PAGE_FAIL,
    GENAI_REGENERATE_PAGE_RESET,
    GENAI_APPROVE_FINAL_REQUEST,
    GENAI_APPROVE_FINAL_SUCCESS,
    GENAI_APPROVE_FINAL_FAIL,
    GENAI_APPROVE_FINAL_RESET,
    GENAI_RETRY_JOB_REQUEST,
    GENAI_RETRY_JOB_SUCCESS,
    GENAI_RETRY_JOB_FAIL,
} from '../constants/genaiConstants';


// Book Generation Reducer
export const bookGenerateReducer = (state = {}, action) => {
    switch (action.type) {
        case GENAI_GENERATE_REQUEST:
            return { loading: true };
        
        case GENAI_GENERATE_SUCCESS:
            return { loading: false, success: true, job: action.payload };
        
        case GENAI_GENERATE_FAIL:
            return { loading: false, error: action.payload };
        
        case GENAI_GENERATE_RESET:
            return {};
        
        default:
            return state;
    }
};


// Generation Job Details Reducer
export const genaiJobDetailsReducer = (state = { job: {} }, action) => {
    switch (action.type) {
        case GENAI_JOB_DETAILS_REQUEST:
            return { ...state, loading: true };
        
        case GENAI_JOB_DETAILS_SUCCESS:
            return { loading: false, job: action.payload };
        
        case GENAI_JOB_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        
        default:
            return state;
    }
};


// My Generation Jobs Reducer
export const genaiMyJobsReducer = (state = { jobs: [] }, action) => {
    switch (action.type) {
        case GENAI_MY_JOBS_REQUEST:
            return { loading: true, jobs: [] };
        
        case GENAI_MY_JOBS_SUCCESS:
            return { loading: false, jobs: action.payload };
        
        case GENAI_MY_JOBS_FAIL:
            return { loading: false, error: action.payload };
        
        default:
            return state;
    }
};


// Story Templates Reducer
export const genaiTemplatesReducer = (state = { templates: [] }, action) => {
    switch (action.type) {
        case GENAI_TEMPLATES_REQUEST:
            return { loading: true, templates: [] };
        
        case GENAI_TEMPLATES_SUCCESS:
            return { loading: false, templates: action.payload };
        
        case GENAI_TEMPLATES_FAIL:
            return { loading: false, error: action.payload };
        
        default:
            return state;
    }
};


// Delete Job Reducer
export const genaiDeleteJobReducer = (state = {}, action) => {
    switch (action.type) {
        case GENAI_DELETE_JOB_REQUEST:
            return { loading: true };
        
        case GENAI_DELETE_JOB_SUCCESS:
            return { loading: false, success: true };
        
        case GENAI_DELETE_JOB_FAIL:
            return { loading: false, error: action.payload };
        
        default:
            return state;
    }
};


// Story Content Reducer
export const genaiStoryReducer = (state = { pages: [] }, action) => {
    switch (action.type) {
        case GENAI_STORY_REQUEST:
            return { loading: true, pages: [] };
        case GENAI_STORY_SUCCESS:
            return {
                loading: false,
                pages: Array.isArray(action.payload?.pages)
                    ? action.payload.pages
                    : Array.isArray(action.payload)
                        ? action.payload
                        : [],
                summary: action.payload?.summary || '',
                message: action.payload?.message,
            };
        case GENAI_STORY_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};


// Images Reducer
export const genaiImagesReducer = (state = { images: {} }, action) => {
    switch (action.type) {
        case GENAI_IMAGES_REQUEST:
            return { loading: true, images: {} };
        case GENAI_IMAGES_SUCCESS:
            return { loading: false, images: action.payload };
        case GENAI_IMAGES_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};


// Approve Story Reducer
export const genaiApproveStoryReducer = (state = {}, action) => {
    switch (action.type) {
        case GENAI_APPROVE_STORY_REQUEST:
            return { loading: true };
        case GENAI_APPROVE_STORY_SUCCESS:
            return { loading: false, success: true };
        case GENAI_APPROVE_STORY_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};


// Regenerate Story Reducer
export const genaiRegenerateStoryReducer = (state = {}, action) => {
    switch (action.type) {
        case GENAI_REGENERATE_STORY_REQUEST:
            return { loading: true };
        case GENAI_REGENERATE_STORY_SUCCESS:
            return { loading: false, success: true };
        case GENAI_REGENERATE_STORY_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};


// Regenerate Cover Reducer
export const genaiRegenerateCoverReducer = (state = {}, action) => {
    switch (action.type) {
        case GENAI_REGENERATE_COVER_REQUEST:
            return { loading: true };
        case GENAI_REGENERATE_COVER_SUCCESS:
            return { loading: false, success: true };
        case GENAI_REGENERATE_COVER_FAIL:
            return { loading: false, error: action.payload };
        case GENAI_REGENERATE_COVER_RESET:
            return {};
        default:
            return state;
    }
};


// Approve Pages Reducer
export const genaiApprovePagesReducer = (state = {}, action) => {
    switch (action.type) {
        case GENAI_APPROVE_PAGES_REQUEST:
            return { loading: true };
        case GENAI_APPROVE_PAGES_SUCCESS:
            return { loading: false, success: true };
        case GENAI_APPROVE_PAGES_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};


// Regenerate Page Reducer
export const genaiRegeneratePageReducer = (state = {}, action) => {
    switch (action.type) {
        case GENAI_REGENERATE_PAGE_REQUEST:
            return { loading: true };
        case GENAI_REGENERATE_PAGE_SUCCESS:
            return { loading: false, success: true };
        case GENAI_REGENERATE_PAGE_FAIL:
            return { loading: false, error: action.payload };
        case GENAI_REGENERATE_PAGE_RESET:
            return {};
        default:
            return state;
    }
};


// Approve Final Reducer
export const genaiApproveFinalReducer = (state = {}, action) => {
    switch (action.type) {
        case GENAI_APPROVE_FINAL_REQUEST:
            return { loading: true };
        case GENAI_APPROVE_FINAL_SUCCESS:
            return { loading: false, success: true };
        case GENAI_APPROVE_FINAL_FAIL:
            return { loading: false, error: action.payload };
        case GENAI_APPROVE_FINAL_RESET:
            return {};
        default:
            return state;
    }
};


// Retry Failed/Stuck Job Reducer
export const genaiRetryJobReducer = (state = {}, action) => {
    switch (action.type) {
        case GENAI_RETRY_JOB_REQUEST:
            return { loading: true };
        case GENAI_RETRY_JOB_SUCCESS:
            return { loading: false, success: true };
        case GENAI_RETRY_JOB_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};
